import { Button } from '@mui/material';
import React, { memo } from 'react';
import CommentIcon from '@mui/icons-material/Comment';
import DatadIcon from '@mui/icons-material/Description';
import { TableRowMode } from 'shared/Table/Table.models';
import './HeaderActions.scss';

interface IHeaderActionsProps {
  isVisibleOrderDataButton: boolean
  isVisibleLogAndFilesButton: boolean
  secondarySidebarMode: TableRowMode | null
  setSecondarySidebarMode: (mode: TableRowMode | null) => void
}

const HeaderActions: React.FC<IHeaderActionsProps> = ({
  secondarySidebarMode,
  setSecondarySidebarMode,
  isVisibleOrderDataButton,
  isVisibleLogAndFilesButton,
}) => {
  if (!isVisibleLogAndFilesButton && !isVisibleOrderDataButton) return null;

  const disabledData = secondarySidebarMode === TableRowMode.COMMENT;
  const disabledComment = secondarySidebarMode === TableRowMode.DATA;

  const setSecondarySidebarInDataMode = () => setSecondarySidebarMode(TableRowMode.DATA);
  const setSecondarySidebarInCommentMode = () => setSecondarySidebarMode(TableRowMode.COMMENT);

  return (
    <div className="header-actions">
      {isVisibleLogAndFilesButton
      && (
        <Button
          variant="outlined"
          disabled={disabledComment}
          startIcon={<CommentIcon />}
          className="header-actions__button"
          onClick={setSecondarySidebarInCommentMode}
        >
          Log&Files
        </Button>
      )}
      {isVisibleOrderDataButton
        && (
          <Button
            variant="outlined"
            disabled={disabledData}
            startIcon={<DatadIcon />}
            className="header-actions__button"
            onClick={setSecondarySidebarInDataMode}
          >
            Data
          </Button>
        )}
    </div>
  );
};

export default memo(HeaderActions);
